// Shared motion presets for framer-motion animations across the app.
// Per ADR-044: all spring configs must be named constants, not inline values,
// so feel stays consistent as new animated features are added.

export const SPRING_SNAPPY = {
  type: 'spring',
  stiffness: 420,
  damping: 38,
  mass: 0.9,
};

export const SPRING_BOUNCY = {
  type: 'spring',
  stiffness: 280,
  damping: 18,
  mass: 1,
};

// Highest-energy entrance — for celebratory pops that should overshoot and
// snap back. Lower damping + higher stiffness than SPRING_BOUNCY gives a
// visible bounce. Pair with a scale keyframe ([small, ~1.1, 1]) for the pop.
export const SPRING_POP = {
  type: 'spring',
  stiffness: 520,
  damping: 14,
  mass: 0.8,
};
